<template>
  <div>
    <md-dialog :md-active="showDialog" id="dlg-import-product-excel" md-height="100%" @md-opened="onDialogOpen">
      <md-dialog-title>Import products.</md-dialog-title>

      <md-dialog-content>
        <md-table
          md-height="100%"
          v-model="products"
          md-sort="name"
          md-sort-order="asc"
          md-card
          md-fixed-header
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Item Number" v-html="checkLifecycle(item)"></md-table-cell>
            <md-table-cell md-label="Item Name Thai">{{ item.detail_th }}</md-table-cell>
            <md-table-cell md-label="Lifecycle Code">{{ showLifeCycle(item.productlifecycle_code) }}</md-table-cell>
          </md-table-row>
        </md-table>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary btn-close" @click="cancel">Close</md-button>
        <md-button class="md-primary btn-import" @click="ImportProduct">Import</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>

import ProductService from "@/services/product";

export default {
  name: "import-product-excel",
  props: ["showDialog", "importedProduct", "products"],
  data() {
    return {};
  },
  created() {
    // console.log(products);
  },
  methods: {
    onDialogOpen(){
        // console.log(this.products)
    },
    cancel() {
      this.$emit("onCancel", false);
    },
    checkLifecycle(item) {
      let lifecycle = [
        "none",
        "41",
        "42",
        "43",
        "44",
        "45",
        "51",
        "52",
        "53",
        "54"
      ];
      if (lifecycle.includes(item.productlifecycle_code)) {
        return (
          "<span style='margin-left:20px;color:red'>" + item.code + "</span>"
        );
      } else {
        return "<span style='margin-left:20px;'>" + item.code + "</span>";
      }
    },
    isDupProduct(code) {
      for (let i = 0; i < this.importedProduct.length; i++) {
        if (this.importedProduct[i].code == code) return true;
      }
      return false;
    },
    ImportProduct() {
      let products = this.products.filter(prod => {
        return prod.productlifecycle_code != "none";
      });
      let prod = products.reduce(function(pV, cV) {
        pV.push(cV.code);
        return pV;
      }, []);
      this.$emit('onImport', prod)
    //   this.searchProductByCode(prod);
    },
    showLifeCycle(code) {
      let lifecycle = ["41", "42", "43", "44", "45", "51", "52", "53", "54"];
      if (lifecycle.includes(code)) return code;
    }
  }
};
</script>

<style lang="scss" scoped>
#dlg-import-product-excel {
  width: 60%;

  .btn-close {
    color: black;
  }
  .btn-import {
    color: black;
    margin-right: 20px;
  }
}

.md-card {
  box-shadow: none;
}
.md-table {
  border: 0px !important;
  height: calc(100vh - 350px);
}
.md-table-row .md-table-cell {
  border: 0px !important;
}
.md-table-fixed-header {
  border: 0px !important;
}
.md-table-content {
  border: 0px !important;
}
</style>

